import React, { PropsWithChildren } from "react";
import "./LoadingSpinner.css";

interface LoadingSpinnerProps extends PropsWithChildren {
    loading: boolean
}

export default function LoadingSpinner(props: LoadingSpinnerProps): JSX.Element {
    return (
        <div className="spinner-container">
            {props.children}
            <div className={`loading-spinner-parent ${props.loading ? "" : "not-loading"}`}>
                {props.loading && <>
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                </>}
            </div>
        </div>
    );
}
